// ─── GitHub Source ────────────────────────────────────────────────────────────

export interface ConnectedRepo {
  id:               string
  user_id:          string
  owner:            string
  name:             string
  description:      string | null
  default_branch:   string
  is_private:       boolean
  display_name:     string | null
  avatar_url:       string | null
  added_at:         string
  last_accessed_at: string | null
}

// ─── Local Filesystem Source ──────────────────────────────────────────────────

export interface LocalSource {
  id:               string
  source_type:      'local'
  display_name:     string
  path:             string   // top-level directory name (for display)
  added_at:         string
  last_accessed_at: string | null
}

// ─── Union + Type Guards ──────────────────────────────────────────────────────

export type ConnectedSource = ConnectedRepo | LocalSource

export function isLocalSource(s: ConnectedSource): s is LocalSource {
  return 'source_type' in s && (s as LocalSource).source_type === 'local'
}

export function isGitHubSource(s: ConnectedSource): s is ConnectedRepo {
  return !isLocalSource(s)
}

// ─── File Node ────────────────────────────────────────────────────────────────

export interface FileNode {
  name:      string
  path:      string
  type:      'file' | 'dir'
  id:        string       // GitHub: blob SHA | Local: relative file path
  children?: FileNode[]
}

// ─── GitHub Internal ──────────────────────────────────────────────────────────

export interface GitHubTreeEntry {
  path:  string
  mode:  string
  type:  'blob' | 'tree' | 'commit'
  sha:   string
  size?: number
  url:   string
}

export type AppView = 'vault' | 'workspace' | 'viewer'

export interface WorkerTreeResponse {
  tree:      GitHubTreeEntry[]
  sha:       string
  truncated: boolean
}
